import classNames from 'classnames';
import type { FC } from 'react';

import Icon from 'components/Icon/Icon';
import { ButtonIconTypes } from 'config/types';
import { getMediaUrl } from 'utils/assets';

import styles from './CasinoCategories.module.scss';

type ChipIconProps = {
  type: ButtonIconTypes;
  customIcon?: string;
  useDefaultIcon?: boolean;
};

const defaultIconsMap: Record<ButtonIconTypes, string> = {
  [ButtonIconTypes.ALL_GAMES]: 'all-games.bold',
  [ButtonIconTypes.FAVOURITES]: 'magic-star',
  [ButtonIconTypes.LOBBY]: 'lobby',
  [ButtonIconTypes.LIVE_CASINO]: 'live-casino.bold',
};

const ChipIcon: FC<ChipIconProps> = ({ type, customIcon, useDefaultIcon }) => {
  const shouldUseDefault = useDefaultIcon || !customIcon;
  const normalizedType = type.replace('_', '-');

  return shouldUseDefault ? (
    <Icon
      className={classNames(styles.icon, styles[normalizedType])}
      name={defaultIconsMap[type]}
    />
  ) : (
    <img
      className={styles.icon}
      src={getMediaUrl(customIcon, 'cms')}
      alt={type}
    />
  );
};

export default ChipIcon;
